export const emailUnsubscribeRoutes = {
  aiUpdateDetails: "ai-updates/:id",
  aiUpdateList: "ai-updates",
} as const;
